import { Button, Grid, Typography } from '@mui/material';
import { deDE, GridColDef } from '@mui/x-data-grid';
import { ILiabilitiesAsset } from '../../../../../../Interfaces/Asset/AssetCategoryTypes';
import { IAssetCategoryId } from '../../../../../../Interfaces/Asset/IAssetCategory';
import { IAssetTypeId } from '../../../../../../Interfaces/Asset/IAssetType';
import { CrudDataGrid } from '../../../generic/CrudDataGrid';

type LiabilityAssetsSectionProps = {
  assets: ILiabilitiesAsset[];
  handleOpen: (
    assetCategoryId: IAssetCategoryId,
    assetTypeId?: IAssetTypeId,
    assetId?: number
  ) => void;
  handleDelete: (assetId: number) => void;
};

const columns: GridColDef<ILiabilitiesAsset, any, any>[] = [
  { field: 'name', headerName: 'Name', width: 150 },
  {
    field: 'value',
    headerName: 'Wert',
    valueGetter: params => getAssetValue(params.row),
    valueFormatter: params => {
      const value = params.value as number;
      return value.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });
    },
    flex: 1,
  },
];

function getAssetValue(asset: ILiabilitiesAsset): number {
  switch (asset.idAssetType) {
    case IAssetTypeId.Loan:
      return asset.data.amount || 0;
    case IAssetTypeId.Mortgage:
      return asset.data.value || 0;
    default:
      return 0;
  }
}

export function LiabilityAssetsSection({
  assets,
  handleOpen,
  handleDelete,
}: LiabilityAssetsSectionProps) {
  const liabilityAssets = assets.filter(
    asset => asset.idAssetCategory === IAssetCategoryId.Liabilities
  );
  return (
    <>
      <Grid item xs={6}>
        <Typography variant='h4' sx={{ mb: 3 }}>
          Schulden
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Button
          sx={{ float: 'right' }}
          variant='contained'
          onClick={() => handleOpen(IAssetCategoryId.Liabilities)}
        >
          Schulden hinzufügen
        </Button>
      </Grid>

      <Grid item xs={12}>
        <CrudDataGrid<ILiabilitiesAsset>
          sx={{ mt: 2 }}
          autoHeight
          localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
          rows={liabilityAssets}
          columns={columns}
          getRowId={row => row.idAsset}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 5,
              },
            },
          }}
          pageSizeOptions={[5]}
          disableRowSelectionOnClick
          onClickEdit={(assetId, assetRow) => {
            handleOpen(
              IAssetCategoryId.Liabilities,
              assetRow.idAssetType,
              Number(assetId)
            );
          }}
          onClickDelete={assetId => {
            handleDelete(Number(assetId));
          }}
        />
      </Grid>
    </>
  );
}
